import AbstractPolyShape from "./AbstractPolyShape";

export default class Line extends AbstractPolyShape {
    type = 'line';

    constructor(provider, data, appearance, speciesIds, label) {
        super(provider, data, appearance, speciesIds, label);
        this.close = null;
    }

    clone(dx, dy) {
        return new Line(
            this.provider,
            {
                coordinates: this.coordinates.map((c) => [c.absX + dx, c.absY + dy]),
            },
            this.appearance.clone(),
            this.speciesIds,
            this.labels.clone(),
        );
    }

    hovered() {
        for (let i = 0; i < this.coordinates.length - 1; i++) {
            if (this.isPointNearLine(this.coordinates[i], this.coordinates[i + 1])) {
                return true;
            }
        }
    }

    isPointNearLine(c1, c2, tolerance = 7) {
        let x = this.view.currentX;
        let y = this.view.currentY;
        let x1 = c1.currentX;
        let y1 = c1.currentY;
        let x2 = c2.currentX;
        let y2 = c2.currentY;

        let dx = Math.abs(x2 - x1);
        let dy = Math.abs(y2 - y1);
        let step = dx > dy ? dx : dy;

        let x_step = dx === 0 ? 0 : (x2 - x1) / step;
        let y_step = dy === 0 ? 0 : (y2 - y1) / step;

        let current_x = x1;
        let current_y = y1;

        for (let i = 0; i < step; i++) {
            let distanceToLine = this.p.dist(current_x, current_y, x, y);

            if (distanceToLine <= tolerance) {
                return true;
            }

            current_x += x_step;
            current_y += y_step;
        }

        return false;
    }

    getSegmentCoordinates(index) {
        return [
            this.coordinates[index],
            this.coordinates[index + 1],
        ];
    }

    export() {
        return {
            type: 'line',
            data: {
                coordinates: this.coordinates.map((c) => [c.absX, c.absY]),
                notes: this.notes,
                ...this.appearance.export(),
                ...this.labels.export(),
            },
            speciesIds: this.speciesIds,
        }
    }

    isPolygon() {
        return false;
    }

    get length() {
        return this.coordinates.length - 1;
    }
}
